/**
 * Client-side mirror of the backend deposit rule
 * (new-backend/admin/src/lib/pricing/depositAmount.ts): a non-negative amount
 * with at most two decimal places, fitting Decimal(10,2). One definition for
 * every surface that edits a deposit — the deposit modal and the product form
 * must not drift on what an admissible amount is.
 */
export const AMOUNT_RE = /^\d+(\.\d{1,2})?$/;
export const MAX_DEPOSIT_AMOUNT = 99999999.99;

/** True for '' (meaning "no amount") and for any admissible amount string. */
export const isValidAmountInput = (trimmed: string): boolean =>
    trimmed.length === 0 ||
    (AMOUNT_RE.test(trimmed) && Number(trimmed) <= MAX_DEPOSIT_AMOUNT);
